import { PureComponent } from "react";
import { func, instanceOf, shape } from "prop-types";
import { ThemeProvider } from "styled-components/macro";
import { rem } from "polished";

import { colors } from "../../styles/Styles.variables";

class Form extends PureComponent {
  render() {
    const { children, formRef, theme, ...rest } = this.props;

    return (
      <ThemeProvider theme={!!themes[theme] ? themes[theme] : themes.dark}>
        <form {...rest} noValidate ref={formRef}>
          {children}
        </form>
      </ThemeProvider>
    );
  }
}

Form.propTypes = {
  formRef: shape({
    current: instanceOf(Element),
  }),
  onSubmit: func,
};

Form.defaultProps = {
  onSubmit: e => e.preventDefault(),
};

const errorBase = {
  color: colors.red400,
};

const inputBase = {
  disabledText: colors.gray700,
  fontSize: rem("18px"),
  lineHeight: 1.5,
  paddingY: rem("4px"),
};

const rangeBase = {
  progress: colors.blue400,
  track: colors.gray900,
  thumbActive: colors.yellow,
  thumbShadow: colors.black,
};

const selectBase = {
  border: colors.gray600,
  disabled: colors.gray600,
  fallbackColor: colors.gray800,
  height: rem("41px"),
};

const textBase = {};

export const themes = {
  dark: {
    error: { ...errorBase },
    input: {
      ...inputBase,
      color: colors.white,
      placeholder: { color: colors.gray600 },
    },
    link: { color: colors.yellow },
    menu: { backgroundColor: colors.gray900 },
    range: {
      ...rangeBase,
      fallback: {
        backgroundColor: colors.black,
        borderColor: colors.blue400,
        textColor: colors.blue400,
      },
      thumb: colors.white,
      tip: colors.black,
    },
    select: { ...selectBase, caret: colors.yellow },
    text: {
      ...textBase,
      backgroundColor: colors.gray900,
      backgroundColorReadOnly: colors.black,
      borderColor: colors.gray900,
      borderColorReadOnly: colors.gray700,
      wysiwygToolbarBorderColor: colors.black,
      wysiwygToolbarColor: colors.gray600,
      wysiwygToolbarColorHover: colors.yellow,
    },
  },
  light: {
    error: { ...errorBase },
    input: {
      ...inputBase,
      color: colors.gray800,
      placeholder: { color: colors.gray300 },
    },
    link: { color: colors.blue500 },
    menu: { backgroundColor: colors.gray250 },
    range: {
      ...rangeBase,
      fallback: {
        backgroundColor: colors.white,
        borderColor: colors.blue400,
        textColor: colors.blue400,
      },
      thumb: colors.gray250,
      tip: colors.black,
    },
    select: { ...selectBase, caret: colors.gray800 },
    text: {
      ...textBase,
      backgroundColor: colors.white,
      backgroundColorReadOnly: colors.gray250,
      borderColor: colors.gray275,
      borderColorReadOnly: colors.gray275,
      wysiwygToolbarBorderColor: colors.gray275,
      wysiwygToolbarColor: colors.gray600,
      wysiwygToolbarColorHover: colors.blue500,
    },
  },
};

export default Form;
